import React from 'react'

export default function Description({children, className}: {children: React.ReactNode, className?: string}) {
  return (
    <p className={`text-lg w-2/3 mt-6 mb-10 ${className || ''}`}>{children}</p>
  )
}
